export function cadastroDvecInRequest(params = {}) {
  return {
    type: '@cadastrodvec/CADASTRODVEC_IN_REQUEST',
    payload: { params },
  };
}

export function findCadastroDvec(idcadastrodvec) {
  return {
    type: '@cadastrodvec/FIND_CADASTRODVEC',
    payload: { idcadastrodvec },
  };
}

export function failedRequest() {
  return {
    type: '@cadastrodvec/FAILED_REQUEST',
  };
}

export function deleteCadastroDvec(idcadastrodvec, params) {
  return {
    type: '@cadastrodvec/DELETE_CADASTRODVEC',
    payload: { idcadastrodvec, params },
  };
}

export function updateCadastroDvec(cadastrodvec, params) {
  return {
    type: '@cadastrodvec/UPDATE_CADASTRODVEC',
    payload: { cadastrodvec, params },
  };
}

export function storeCadastroDvec(cadastrodvec, params) {
  return {
    type: '@cadastrodvec/STORE_CADASTRODVEC',
    payload: { cadastrodvec, params },
  };
}

export function successInRequest(
  cadastrodvec,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@cadastrodvec/SUCCESS_IN_REQUEST',
    payload: { cadastrodvec, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(cadastrodvec) {
  return {
    type: '@cadastrodvec/SUCCESS_REQUEST',
    payload: { cadastrodvec },
  };
}

export function successRemove(params) {
  return {
    type: '@cadastrodvec/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@cadastrodvec/RECORD_FILTERING',
    payload: { params },
  };
}
